import { Paper, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { browserHistory, withRouter } from "react-router";
import SvEvents from "./SvEvents";
import Categories from "./Categories";

const MaintenancePrograms = () => {
    const [tabValue, setTabValue] = useState(window.location.search.includes('category') ? 1 : 0);

    const handleTabChange = (tabindex) => {
        setTabValue(tabindex);
        if (tabindex === 1) {
            browserHistory.push('/config-data/maintenancePrograms/?category');
        } else {
            browserHistory.push('/config-data/maintenancePrograms');
        }
    };

    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper className="tech-specs-card" style={{ height: `${window.innerHeight - 90}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '0px' }}>
                        <div square style={{ padding: '4px 8px' }}>
                            <Paper>
                            <Tabs
                                value={tabValue}
                                onChange={(event, tabindex) => handleTabChange(tabindex)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Shop Visit Events" />
                                <Tab label="Categories" />
                            </Tabs>
                            </Paper>
                            {tabValue === 0 ? <SvEvents /> : <Categories />}
                        </div>
                </div>
            </Paper>
        </section>
    );
};

export default withRouter(MaintenancePrograms);
